import { useQuery } from "@tanstack/react-query";
import { useAuth } from "@clerk/clerk-react";
import { createApiClient } from "../api/ApiClient";
import type { BillingInterval } from "./useProduct";

export interface DashboardProduct {
  id: string;
  name: string;
  amount: number | null;
  currency: string | null;
  billing_interval: BillingInterval | null;
  billing_interval_count: number | null;
  active: boolean;
  total_subscribers: number;
}

export function useDashboardProducts() {
  const { getToken } = useAuth();
  const api = createApiClient(getToken);

  return useQuery({
    queryKey: ["dashboard-products"],
    queryFn: () => api.get<DashboardProduct[]>("/vendors/dashboard/products"),
  });
}
